export default "__VITE_ASSET__Kiw_Rd5b__"